import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const assetReqAdapter = createEntityAdapter({})
const initialState = assetReqAdapter.getInitialState()

export const assetReqApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getassetReq: builder.query({
            query: () => ({
                url: '/assetreq',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedassetReq = responseData.map(assetReq => {
                    assetReq.id = assetReq._id
                    return assetReq
                });
                return assetReqAdapter.setAll(initialState, loadedassetReq)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'AssetReq', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'AssetReq', id }))
                    ]
                } else return [{ type: 'AssetReq', id: 'LIST' }]
            }
        }),
        addNewassetReq: builder.mutation({
            query: initialUserData => ({
                url: '/assetreq',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'AssetReq', id: "LIST" },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),
        updateassetReq: builder.mutation({
            query: initialUserData => ({
                url: '/assetreq',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }), 
        updateReqIssuer: builder.mutation({
            query: initialUserData => ({
                url: '/assetreq/issuer',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }), 
        updateassetReqstatus: builder.mutation({
            query: initialUserData => ({
                url: '/assetreq/updatestatus',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }), 
        updateReqPartialIssue: builder.mutation({
            query: initialUserData => ({
                url: '/assetreq/partialrequpdate',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),
        updateBoPartialAsset: builder.mutation({
            query: initialData => ({
                url: '/assetreq/partialbo',
                method: 'PUT',
                body: {
                    ...initialData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),
        updateStorePartialAsset: builder.mutation({
            query: initialData => ({
                url: '/assetreq/partialstore',
                method: 'PUT',
                body: {
                    ...initialData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),             
        updateassetReqFinal: builder.mutation({
            query: initialUserData => ({
                url: '/assetreq/final',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),       
        deleteassetReq: builder.mutation({
            query: ({ id }) => ({
                url: `/assetreq`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetReq', id: arg.id },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),
        getFilteredAssetRequests: builder.query({
            query: ({ page, limit, filters = {} }) => {
                return {
                    url: "/assetreq/filtered",
                    params: { ...filters, page, limit },
                    validateStatus: (response) => response.status === 200,
                };
            },
            transformResponse: (responseData) => {
                
                const transformedData = {
                    requests: responseData.requests?.map((request) => ({
                        ...request,
                        id: request._id, // Ensure `id` is mapped correctly
                    })) || [],
                    totalFilteredRequests: responseData.totalFilteredRequests || 0,
                    totalPages: responseData.totalPages || 1,
                };
                
                return transformedData;
            },
            providesTags: (result) =>
                result?.requests
                ? [
                    { type: "AssetReq", id: "LIST" },
                    ...result.requests.map((request) => ({
                        type: "AssetReq",
                        id: request.id,
                    })),
                    ]
                : [{ type: "AssetReq", id: "LIST" }],
        }),
        // Unread message endpoints
        markAsRead: builder.mutation({
            query: ({ requestId, requestType }) => ({
                url: '/assetreq/mark-as-read',
                method: 'POST',
                body: {
                    requestId,
                    requestType
                }
            }),
            invalidatesTags: [
                { type: 'AssetReq', id: "LIST" },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),
        getFilteredUnreadCounts: builder.query({
            query: ({ userId, sent_to_tags, req_store }) => ({
                url: '/assetreq/filtered-unread-counts',
                method: 'POST',
                body: {
                    userId,
                    sent_to_tags,
                    req_store
                }
            }),
            transformResponse: (responseData) => {
                return responseData.unreadCounts || {};
            },
            providesTags: [{ type: 'UnreadCounts', id: 'LIST' }]
        }),
        getUnreadCounts: builder.query({
            query: ({ userId, office, roles }) => ({
                url: '/assetreq/unread-counts',
                method: 'POST',
                body: {
                    userId,
                    office,
                    roles
                }
            }),
            transformResponse: (responseData) => {
                return responseData.data || {};
            },
            providesTags: [{ type: 'UnreadCounts', id: 'LIST' }]
        }),
        markAllAsRead: builder.mutation({
            query: ({ userId, tabType, subTabType, requestType }) => ({
                url: '/assetreq/mark-all-read',
                method: 'POST',
                body: {
                    userId,
                    tabType,
                    subTabType,
                    requestType
                }
            }),
            invalidatesTags: [
                { type: 'AssetReq', id: "LIST" },
                { type: 'UnreadCounts', id: 'LIST' }
            ]
        }),
    }),
})

export const {
    useGetassetReqQuery,
    useAddNewassetReqMutation,
    useUpdateassetReqMutation,
    useDeleteassetReqMutation,
    useUpdateassetReqstatusMutation,
    useUpdateReqPartialIssueMutation,
    useUpdateBoPartialAssetMutation,
    useUpdateStorePartialAssetMutation,
    useUpdateassetReqFinalMutation,
    useUpdateReqIssuerMutation,
    useGetFilteredAssetRequestsQuery,
    useLazyGetFilteredAssetRequestsQuery, // ← Auto-generated lazy version
    useMarkAsReadMutation,
    useGetFilteredUnreadCountsQuery,
    useGetUnreadCountsQuery,
    useLazyGetUnreadCountsQuery,
    useMarkAllAsReadMutation
} = assetReqApiSlice

// returns the query result object
export const selectassetReqResult = assetReqApiSlice.endpoints.getassetReq.select()

// creates memoized selector
const selectassetReqData = createSelector(
    selectassetReqResult,
    assetReqResult => assetReqResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllassetReq,
    selectById: selectassetReqById,
    selectIds: selectassetReqIds
    // Pass in a selector that returns the users slice of state
} = assetReqAdapter.getSelectors(state => selectassetReqData(state) ?? initialState)